import { Injury } from "../../../model/Dto/Injury";
import { ApiRequest, RequestMethod } from "../../request";

const URL = "/api/dict/injury";

export async function getAllInjuries(): Promise<Injury[]> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.GET);
  apiRequest.setUrl(URL);

  const response: any = await apiRequest.send();

  return response.data.map((faction: any) => ({
    id: faction["id"],
    name: faction["name"],
  }));
}
